export default __webpack_public_path__ + "static/media/C99D8565-4A6A-4875-9F51-6A6FF290D6A0_1_105_c.65ce0a75.jpeg";